module.exports = "/fonts/vendor/@fontsource/inter/files/inter-all-600-normal.woff?f212c16eb5eaad42290e1016df62c012";